function Solutions() {
  return (
    <>
   
    </>
  );
}

export default Solutions;
